/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';

@autoinject()
export class HouseholdCaseCareTeamPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected householdCaseId!: string;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }

    protected async canActivate(params: { householdCaseId: string }): Promise<boolean> {
        if(!params.householdCaseId) { throw new Error('Missing or invalid householdCaseId parameter'); }

        return true;
    }

    protected async activate(params: { householdCaseId: string }): Promise<void> {
        if(this.householdCaseId !== params.householdCaseId) { this.householdCaseId = params.householdCaseId; }
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}
